import Icon from '@tiger/icons';
import { FC } from 'react';
import { FormCheck, FormCheckProps } from 'react-bootstrap';
import { Fade } from 'components/Transition';
import classlist from 'utils/classlist';
import styles from './style.scss';

interface BorderRadioProps extends FormCheckProps {
    active?: boolean;
    /**
     * 选中有三种类型的样式:
     * radio: 左侧为文案，右侧展示radio原点
     * checkbox: 一个checkbox的对钩
     * border: 只有边框高亮 没有别的样式
     */
    checkedType: 'radio' | 'checkbox' | 'border';
    disabled?: boolean;
    labelOptions: {
        img?: string;
        imgClassName?: string;
        title: string;
        showArrow?: boolean;
        description?: React.ReactNode;
    };
}

/**
 * 项目中存在一些用边框的形式展示的单选框, 这里提供一个组件统一处理样式
 * 设计稿: https://www.figma.com/design/AdKlCAkKEqN9cobUASsjpQ/OA-%E7%BE%8E%E5%9B%BDIRA%E8%B4%A6%E6%88%B7?node-id=329-1041&node-type=text&m=dev
 * 参考设计稿中上方账户类型选择的样式
 */
const BorderRadio: FC<BorderRadioProps> = props => {
    const { value, id, labelOptions, children, active, disabled, checkedType, ...restProps } = props;
    const { img, description, title, imgClassName, showArrow } = labelOptions;

    return (
        <div className={styles.root}>
            <FormCheck
                className={classlist(styles.formCheck, {
                    [styles.invalid]: restProps.isInvalid,
                    [styles.active]: active,
                    [styles.disabled]: disabled,
                    [styles.checkbox]: checkedType === 'checkbox',
                    [styles.radio]: checkedType === 'radio'
                })}
                type="radio"
                value={value}
                id={id}
                disabled={disabled}
                label={
                    <div className={classlist(styles.labelContainer)}>
                        {img && <img className={classlist(styles.labelImage, imgClassName)} src={img} alt={title} />}
                        <div className={styles.labelContent}>
                            <div className={styles.title}>
                                {title}
                                {showArrow && <Icon className={styles.arrow} type="right" />}
                            </div>
                            {description && <div className={classlist(styles.description, 'mt-2')}>{description}</div>}
                        </div>
                    </div>
                }
                // 这里必须要处理, 因为上层组件可能会往下透传属性, 比如RadioGroup组件, 会向下透传处理一些东西
                {...restProps}
            />
            {children && (
                <Fade in={active} exit={false}>
                    {children}
                </Fade>
            )}
        </div>
    );
};

export default BorderRadio;
